import { render, staticRenderFns } from "./financeapproval.vue?vue&type=template&id=c8f49f72&"
import script from "./financeapproval.vue?vue&type=script&lang=js&"
export * from "./financeapproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports